const routs = {
  HomeView: "/",
  ContactsView: "/contacts",
  LoginView: "/login",
  RegisterView: "/register",
};

export default routs;
